module.exports = __webpack_public_path__ + "static/img/dai_shen_pi.9e3b207.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/dai_shen_pi.png
// module id = tEQp
// module chunks = 2